import { ApolloQueryResult } from '@apollo/client';
import { commonContexts } from '@css-xp/base';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import React from 'react';
import { BillingInformation } from './billing-information';
import './billing-tab.scss';

interface Props {
  entitlement: EntitlementDetails;
  refetch?: () => Promise<ApolloQueryResult<unknown>>;
}

/**
 * Billing details is a combination of Transaction (Billing) Account / Invoice Group snapshots
 */
export const BillingTab = ({ entitlement, refetch }: Props) => {
  const {
    // error, todo: error handling
    loading: isTransactionAccountLoading,
    data,
    getTransactionAccount,
  } = React.useContext(commonContexts.TransactionAccountContext);

  if (!entitlement || isTransactionAccountLoading) {
    return <div data-testid="loading-or-empty-placeholder" />;
  }

  const transactionAccount = getTransactionAccount(data);

  return (
    <div data-testid="entitlement-billing-tab">
      <BillingInformation
        data-testid="entitlement-billing-information"
        transactionAccount={transactionAccount}
        entitlement={entitlement}
        refetch={refetch}
      />
    </div>
  );
};

export default BillingTab;
